
import CsMonthly from './pages/Cs/CsMonthly';
import CsForm from './pages/Cs/CsForm';
import CsWeekly from './pages/Cs/CsWeekly';


import FlyEngMngrParent from './pages/Service/Manage/flyEng/Parent';
import FlyEngMngrChild from './pages/Service/Manage/flyEng/Child';

import TomoplayMngrParent from './pages/Service/Manage/Tomoplay/Parent';
import TomoplayMngrChild from './pages/Service/Manage/Tomoplay/Child';

import MngrParent from './pages/Service/Manage/index_parent.js';
import MngrChild from './pages/Service/Manage/index_child.js';

import ManagementWithdrawal from './pages/Service/Manage/Withdrawal';

import TasGlobalContract from './pages/TAS4/Stat/Contract/contract.js';
import TasGlobalState from './pages/TAS/Global/state.js';
import TasBranch from './pages/TAS4/Stat/Contract/branch.js';
import TasBranch_Main from './pages/TAS/Branch/branch_index.js';
import TasNursery from './pages/TAS/Nursery';

import MapContract from './pages/TAS/Map/MapContract.js';
import MapBranch from './pages/TAS/Map/MapBranch.js';

import ManagementContract from './pages/TAS4/Contract/index.js';
import ManagementNursery from './pages/TAS4/Nursery/index.js';
import ManagementNurseryRefine from './pages/TAS4/NurseryRefine';
import ManagementSubscriber from './pages/TAS4/Subscriber';

import StatOldTomonote from './pages/TAS4/Stat/Old/tomonote';
import StatOldTomobooksParent from './pages/TAS4/Stat/Old/tomobooks';
import StatTomonoteHQ from './pages/TAS4/Stat/App/Tomonote/index_hq';
import StatTomonoteBranch from './pages/TAS4/Stat/App/Tomonote/index_branch';

import BranchInfo from './pages/TAS4/Branch/index.js';

import SearchDevice from './pages/TAS/Search/Device.js';
import SearchDeviceBooksParent from './pages/TAS/Search/DeviceBooksParent';
import SearchSystemMessage from './pages/TAS/Search/SystemMessage.js';

import ManageUsers from './pages/Manager/Users';
import ManageServerConfig from './pages/Manager/ServerConfig';
import ManageMenu from './pages/Manager/Menu';
import ManageMenuCategory from './pages/Manager/MenuCategory';
import ManageUserGroup from './pages/Manager/UserGroup';
import ManagementProduct from './pages/Manager/Product';



// import FlyEngStatHome from './pages/FlyEng/Stat/Home';
// import FlyEngStatClass from './pages/FlyEng/Stat/Class';
import FlyEngStatClassHQ from './pages/TAS4/Stat/App/flyEng/Stat/New/Class/index_hq';
import FlyEngStatClassBranch from './pages/TAS4/Stat/App/flyEng/Stat/New/Class/index_branch';
import FlyEngStatHomeHQ from './pages/TAS4/Stat/App/flyEng/Stat/New/Home/index_hq';
import FlyEngStatHomeBranch from './pages/TAS4/Stat/App/flyEng/Stat/New/Home/index_branch';

import FlyEngStatHomeHQ2022 from './pages/TAS4/Stat/App/flyEng/Stat/2022/Home/index_hq';
import FlyEngStatHomeBranch2022 from './pages/TAS4/Stat/App/flyEng/Stat/2022/Home/index_branch';

import FlyEngStatReport from './pages/TAS4/Stat/App/flyEng/Stat/Report';
import TomoplayStatReport from './pages/TAS4/Stat/App/Tomoplay/Report';

import AppVersion from './pages/Service/AppVersion';

import NotReady from './pages/NotReady';

import StatBooksHq from './pages/TAS4/Stat/App/Books/index_hq';
import StatBooksBranch from './pages/TAS4/Stat/App/Books/index_branch';

import StatPlayHq from './pages/TAS4/Stat/App/Tomoplay/index_hq';
import StatPlayBranch from './pages/TAS4/Stat/App/Tomoplay/index_branch';

import StatMomoHq from './pages/TAS4/Stat/App/Momo/index_hq';
import StatMomoBranch from './pages/TAS4/Stat/App/Momo/index_branch';

import StatPlayDDHq from './pages/TAS4/Stat/App/PlayDD/index_hq';
import StatPlayDDBranch from './pages/TAS4/Stat/App/PlayDD/index_branch';
import StatPlayDDReport from './pages/TAS4/Stat/App/PlayDD/Report';

import StatJelliingClassHq from './pages/TAS4/Stat/App/Jelliing/Class/index_hq';
import StatJelliingClassBranch from './pages/TAS4/Stat/App/Jelliing/Class/index_branch';
import StatJelliingReport from './pages/TAS4/Stat/App/Jelliing/Report';

import StatJelliingHomeHq from './pages/TAS4/Stat/App/Jelliing/Home/index_hq';
import StatJelliingHomeBranch from './pages/TAS4/Stat/App/Jelliing/Home/index_branch';

export {
    CsMonthly, CsForm, CsWeekly, 
    FlyEngMngrParent, FlyEngMngrChild, 
    TomoplayMngrParent, TomoplayMngrChild, MngrParent, MngrChild,
    ManagementWithdrawal,
    TasGlobalContract, TasGlobalState, TasBranch, TasBranch_Main, TasNursery,
    StatOldTomonote, StatOldTomobooksParent,
    StatTomonoteHQ, StatTomonoteBranch,
    MapContract, MapBranch, 
    ManagementContract,
    ManagementNursery, ManagementNurseryRefine,
    ManagementSubscriber,
    BranchInfo,
    SearchDevice, SearchDeviceBooksParent, SearchSystemMessage,
    FlyEngStatClassHQ, FlyEngStatClassBranch, FlyEngStatHomeHQ, FlyEngStatHomeBranch, FlyEngStatHomeHQ2022, FlyEngStatHomeBranch2022, FlyEngStatReport,
    StatBooksHq, StatBooksBranch, 
    StatPlayBranch, StatPlayHq, TomoplayStatReport,
    StatMomoHq, StatMomoBranch,
    StatPlayDDBranch, StatPlayDDReport,
    StatPlayDDHq,
    StatJelliingClassHq, StatJelliingReport,
    StatJelliingClassBranch,
    StatJelliingHomeBranch, StatJelliingHomeHq,
    AppVersion,
    ManageUsers, ManageServerConfig, ManageMenu, ManageMenuCategory, ManageUserGroup,
    ManagementProduct,
    NotReady,
}





